import type { SVGProps } from "react";
const SenecPictogramPlaceSetting = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M6 6H7.5C17.6885 6 24 14.5946 24 24C24 33.4054 17.6885 42 7.5 42H6V38C6 37.4477 6.44772 37 7 37C7.55228 37 8 37.4477 8 38V39.992C16.5261 39.7175 22 32.4309 22 24C22 15.5691 16.5261 8.28249 8 8.00801V33C8 33.5523 7.55228 34 7 34C6.44772 34 6 33.5523 6 33V6Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 10C25 7.79086 26.7909 6 29 6C31.2091 6 33 7.79086 33 10V16C33 17.8638 31.7252 19.4299 30 19.874V42H28V19.874C26.2748 19.4299 25 17.8638 25 16V10ZM29 8C27.8954 8 27 8.89543 27 10V16C27 17.1046 27.8954 18 29 18C30.1046 18 31 17.1046 31 16V10C31 8.89543 30.1046 8 29 8Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35 11.9C35 8.64152 37.6415 6 40.9 6H42V42H40V23H35V11.9ZM40 21V8.10436C38.28 8.51066 37 10.0559 37 11.9V21H40Z"
            fill="currentColor"
        />
        <path
            d="M10.0572 11.3496C10.2412 10.8289 10.8125 10.5559 11.3332 10.74C16.4343 12.5429 20 17.621 20 24C20 30.379 16.4343 35.4571 11.3332 37.26C10.8125 37.4441 10.2412 37.1711 10.0572 36.6504C9.87311 36.1297 10.146 35.5584 10.6668 35.3743C14.8873 33.8826 18 29.621 18 24C18 18.379 14.8873 14.1174 10.6668 12.6257C10.146 12.4416 9.87311 11.8703 10.0572 11.3496Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramPlaceSetting;
